import { Dialog } from '@headlessui/react';
import { validateOrgno } from '../../utils/validate-orgno';
import { mrfZipGroups } from '../../constants/mrf-zip-groups';

function CustomZipDialog(props: any): JSX.Element {
  const eventId = props.environment?.eventId;
  const currentOrder = props.orders?.[props.activePersonNo];

  if (eventId !== 9983 || !currentOrder) return null;

  const city = currentOrder?.person?.city;
  const orgNo = validateOrgno(currentOrder?.company?.orgNo, 'swe') ? currentOrder?.company?.orgNo : '';
  const isOpen = orgNo !== '' && (!city || city === '');

  const cities = mrfZipGroups?.[orgNo?.replace('-', '') as keyof typeof mrfZipGroups] ?? [];

  if (!cities.length) return null;

  const handleCityChange = (city: string) => {
    const order = props.orders[props.activePersonNo];

    if (order!.person === undefined) order!.person = {};

    order.person.city = city;
    props.updateOrder(order);
  };

  return (
    <Dialog open={isOpen} onClose={() => {}} className="relative z-50">
      <div className="fixed inset-0 bg-black/10" aria-hidden="true" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className=" space-y-4 border border-zinc-200 rounded-md bg-white p-12">
          <Dialog.Title className="font-bold">Postorter</Dialog.Title>
          <Dialog.Description className="text-sm">Välj en av följande postorter</Dialog.Description>
          <div className="flex flex-col w-[350px] gap-2 mt-4 max-h-64 overflow-y-auto">
            {cities.map(city => (
              <button className="bg-zinc-50 border border-zinc-200 rounded-md" onClick={() => handleCityChange(city)}>
                {city}
              </button>
            ))}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default CustomZipDialog;
